// src/components/modals/OpenShiftModal.jsx
// Modal for opening shift with cash balance

import { useState } from 'react'
import { X } from 'lucide-react'
import PropTypes from 'prop-types'

const OpenShiftModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  const [openBalance, setOpenBalance] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    
    if (!openBalance || parseFloat(openBalance) < 0) {
      return
    }

    onConfirm(openBalance)
  }

  const handleClose = () => {
    setOpenBalance('')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">Open Shift</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={loading}
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="openBalance" className="block text-sm font-medium text-gray-700 mb-2">
              Opening Cash Balance
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                Rs.
              </span>
              <input
                type="number"
                id="openBalance"
                value={openBalance}
                onChange={(e) => setOpenBalance(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                placeholder="0.00"
                min="0"
                step="0.01"
                required
                disabled={loading}
                autoFocus
              />
            </div>
          </div>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading || !openBalance || parseFloat(openBalance) < 0}
            >
              {loading ? 'Opening...' : 'Open Shift'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

OpenShiftModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default OpenShiftModal
